import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Cloud, CloudDrizzle, CloudFog, CloudLightning, CloudRain, CloudSnow, CloudSun, Sun } from "lucide-react";
import { api } from "@/lib/api";

const icon = (c = "") => /thunder/i.test(c) ? CloudLightning : /snow/i.test(c) ? CloudSnow : /drizzle/i.test(c) ? CloudDrizzle : /rain|shower/i.test(c) ? CloudRain
  : /fog/i.test(c) ? CloudFog : /partly|mostly/i.test(c) ? CloudSun : /clear/i.test(c) ? Sun : Cloud;
const deg = (v) => (v == null ? "–" : `${Math.round(v)}°`);

export const WeatherLine = () => {
  const [w, setW] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/weather/me").then((r) => setW(r.data)).catch(() => {}); }, []);
  if (!w) return null;
  if (!w.available) return <Link to="/settings" className="block text-xs text-slate-500 hover:text-slate-800" data-testid="weather-setup">{w.reason} →</Link>;
  const Icon = icon(w.condition);
  return (
    <div className="space-y-1.5" data-testid="weather-line">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-sm text-slate-700">
        <Icon size={16} className="text-amber-600" />
        <span className="font-medium" data-testid="weather-now">{w.place && `${w.place} `}{deg(w.temp)}</span>
        {w.condition && <span className="text-slate-500">· {w.condition}</span>}
        <span className="text-slate-500" data-testid="weather-high-low">· H {deg(w.high)} L {deg(w.low)}</span>
        <a href={w.agency_url || "https://open-meteo.com"} target="_blank" rel="noreferrer" className="ml-auto text-[11px] text-slate-400 hover:text-slate-600" data-testid="weather-source">{w.model_label}</a>
      </div>
      {w.warnings?.slice(0, open ? 3 : 1).map((x, i) => (
        <a key={i} href={x.link || w.agency_url} target="_blank" rel="noreferrer" data-testid={`weather-warning-${i}`}
          className="flex items-start gap-1.5 rounded-lg border border-rose-200 bg-rose-50 px-2.5 py-1.5 text-xs font-medium text-rose-800 hover:bg-rose-100">
          <AlertTriangle size={13} className="mt-0.5 shrink-0" /><span>{x.title}<span className="font-normal text-rose-700/80"> · {w.agency}</span></span></a>))}
      {w.warnings?.length > 1 && <button onClick={() => setOpen(!open)} className="text-[11px] font-medium text-rose-700 hover:underline" data-testid="weather-warnings-toggle">{open ? "Show fewer warnings" : `+${w.warnings.length - 1} more warning${w.warnings.length > 2 ? "s" : ""} for ${w.warnings_scope}`}</button>}
    </div>
  );
};
